import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import {
  hasEqualUeberschusssystemValue,
  temporaryField,
} from '@/features/Sparten/shared/provident/inputDehydrationDefinition';

export const buInputDehydrationDefinitions: ConditionalRequestDefinition[] = [
  hasEqualUeberschusssystemValue,
  temporaryField,
];
